export default function AboutSection() {
  return (
    <section className="bg-white py-16 px-6" id="about">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
          About <span className="text-blue-600">Jivan Jyoti Trust</span>
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-10">
          Empowering underprivileged communities through education, compassion, and long-term support since 1962.
        </p>

        {/* Stats or Values */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-8">
          <div className="p-6 bg-blue-50 rounded-xl hover:shadow-xl transition">
            <p className="text-3xl font-bold text-blue-600">20,000+</p>
            <p className="mt-2 text-sm text-gray-600">Students Educated</p>
          </div>
          <div className="p-6 bg-blue-50 rounded-xl hover:shadow-xl transition">
            <p className="text-3xl font-bold text-blue-600">60%+</p>
            <p className="mt-2 text-sm text-gray-600">Girl Students</p>
          </div>
          <div className="p-6 bg-blue-50 rounded-xl hover:shadow-xl transition">
            <p className="text-3xl font-bold text-blue-600">60+ Yrs</p>
            <p className="mt-2 text-sm text-gray-600">Of Service</p>
          </div>
          <div className="p-6 bg-blue-50 rounded-xl hover:shadow-xl transition">
            <p className="text-3xl font-bold text-blue-600">Behrampura</p>
            <p className="mt-2 text-sm text-gray-600">Serving Poorest Areas</p>
          </div>
        </div>

        {/* Mission */}
        <div className="mt-16 max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold text-gray-800 mb-4">🎯 Our Mission</h3>
          <p className="text-gray-700 text-base leading-relaxed">
            To provide inclusive education, promote gender equality, and uplift communities through awareness, literacy, and vocational training — building a confident and compassionate future generation.
          </p>
        </div>

        {/* CTA */}
        <div className="mt-10">
          <a
            href="/about"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg text-lg font-medium hover:bg-blue-700 transition"
          >
            Learn More About Us →
          </a>
        </div>
      </div>
    </section>
  );
}
